import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Form, Input, Button, Select } from 'antd';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Couverture = function Couverture() {
  var onFinish = function onFinish(value) {};
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      style: {
        marginTop: '25px'
      },
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg"
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius",
            style: {
              background: '#2658A4'
            },
            children: /*#__PURE__*/_jsx(Form, {
              onFinish: onFinish,
              layout: "horizontal"
            })
          })
        })]
      })
    })
  });
};
export default Couverture;